import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SvgIcon,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

import {
  AddCircleOutlineOutlined,
  AddPhotoAlternateOutlined,
  CheckCircle,
  Group,
  RemoveCircleOutline,
} from "@mui/icons-material";
import { useTheme } from "@mui/system";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import { LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";

import { states } from "../../../../../utils/StatesList.utils";
import { DialogStyle } from "../dialog/dialogBody/Dialog.styles";
import AppButton from "../../../../base/AppButton.component";
import { InputValidation } from "../../../../../utils/InputValidationRegex";
import {
  TYPE,
  firstOfMonth,
  today,
  weekDays,
} from "../../../../../utils/Utils";
import HocPopup from "../../../../../hoc/hocPopup";
import ImageCropper from "../../../../../utils/cropImage";
import { useAuth } from "../../../../../context/Auth.context";
import noImage from "../../../../../assets/images/no-image.jpg";

import {
  CREATE_USER,
  MANAGE_ASSOCIATION,
  MANAGE_CRM_USERS,
  MANAGE_DEALERSHIP,
} from "../../../../../graphql/mutation/mutation";
import {
  SEARCH_MANAGER,
  SEARCH_PATNERS,
  FETCH_MAKES,
} from "../../../../../graphql/query/query";
import { useAppContext } from "../../../../../context/App.context";
import DealershipService from "../dealershipServices/DealershipService";
import { ServiceData } from "../../../omniService/ServiceData";

const options = Array.from({ length: 40 }, (_, index) =>
  (index + 1).toString(),
);
const logoutoptions = Array.from({ length: 26 }, (_, index) =>
  (index + 5).toString(),
);


const NewDealershipForm = (props) => {
  const theme = useTheme();
  const auth = useAuth();
  const app = useAppContext();
  const params = useParams();
  const navigate = useNavigate();
  const { data, edit = false, dialog, refetchdealer, setValue } = props;
  const { data: makesData, loading: makesLoading } = useQuery(FETCH_MAKES, {
  fetchPolicy: "network-only",
});

const brandNameOptions = makesData?.fetchMakes?.makeArray || [];
  const [selectedImage, setSelectedImage] = useState(null);

  const [showMainContact, setShowMainContact] = useState(false);
  const [associate, setAssociate] = useState(false);
  const [associateEmail, setAssociateEmail] = useState("");
  const [newUsers, setNewUsers] = useState([]);
  const [newAssociates, setNewAssociates] = useState([]);
  const [checked, setChecked] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const [dealer, setDealer] = useState({
    dealershipName: "",
    brandName: "",
    firstName: "",
    lastName: "",
    logoUrl: "",
    percentage: "30",
    logout_time: 30,
    referral_notification_id: 3,
    patner_name: "",
    patner_id: 0,
    verification_workflow_id: 1,
    address: {
      poBox: "",
      street: "",
      city: "",
      state: "",
      zipcode: "",
      country: "US",
    },
    contact: {
      email: "",
      phoneNumber: "",
    },
    mainContact: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
    },
    subscription: {
      cost: "0",
      limit: "0",
      overage: "0",
      payload: 2,
      quote_cost: "0",
    },
    manager_employee: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      designation: "employee",
      verifyNotification: 3,
      appointmentNotification: 3,
      reviewNotification: 3,
      // referralNotification: 3,
      receiveNotification: 3,
      verification_workflow_id: 1,
    },
    dealershipTiming:
      weekDays.map((day) => ({
        day,
        opens_at: "09:00",
        closes_at: "21:00",
        isclosed: false,
      })) || [],
    services: [
      {
        service_id: 1,
        is_active: true,
        service_text: ServiceData[0]?.english_text,
        es_service_text: ServiceData[0]?.spanish_text,
      },
      {
        service_id: 2,
        is_active: true,
        service_text: ServiceData[1]?.english_text,
        es_service_text: ServiceData[1]?.spanish_text,
      },
      {
        service_id: 3,
        is_active: true,
        service_text: ServiceData[2]?.english_text,
        es_service_text: ServiceData[2]?.spanish_text,
      },
      {
        service_id: 4,
        is_active: true,
        service_text: ServiceData[3]?.english_text,
        es_service_text: ServiceData[3]?.spanish_text,
      },
    ],
  });
  const handleService = (service, value) => {
    const index = dealer.services.findIndex(
      (s) => s?.service_id === service?.service_id,
    );

    if (index === -1) return;

    const updatedValue = [...dealer.services];

    updatedValue[index] = {
      ...updatedValue[index],
      is_active: value,
    };

    setDealer((prev) => ({
      ...prev,
      services: updatedValue,
    }));
  };

  const parseTimeStringToDate = (timeString) => {
    if (typeof timeString === "string") {
      const [hours, minutes] = timeString.split(":");
      const date = new Date();
      date.setHours(hours);
      date.setMinutes(minutes);
      return date;
    }
    return null;
  };
  const formatTimeToString = (date) => {
    return format(date, "HH:mm");
  };
  const handleStartTimeChange = (index, newTime) => {
    const updatedOpenHour = [...dealer.dealershipTiming];

    updatedOpenHour[index].opens_at = formatTimeToString(newTime);

    setDealer((prev) => ({
      ...prev,
      dealershipTiming: updatedOpenHour,
    }));
  };

  const handleEndTimeChange = (index, newTime) => {
    const updatedOpenHour = [...dealer.dealershipTiming];
    updatedOpenHour[index].closes_at = formatTimeToString(newTime);
    setDealer((prev) => ({
      ...prev,
      dealershipTiming: updatedOpenHour,
    }));
  };

  const handleCheckboxChange = (index) => {
    const updatedOpenHour = [...dealer.dealershipTiming];
    updatedOpenHour[index].isclosed = !updatedOpenHour[index].isclosed;
    setDealer((prev) => ({
      ...prev,
      dealershipTiming: updatedOpenHour,
    }));
  };

  useEffect(() => {
    if (data && edit) {
      let mergedServices;
      if (data?.serviceId) {
        const dbServices =
          data?.serviceId?.map((s) => ({
            id: s?.id,
            service_id: s?.service_id,
            is_active: s?.is_active,
            service_text: s?.service_text || "",
            es_service_text: s?.es_service_text || "",
          })) || [];
        mergedServices = dealer.services?.map((def) => {
          const found = dbServices.find((d) => d.service_id === def.service_id);
          return found ? { ...def, ...found } : def;
        });
      }
      setDealer({
        dealershipName: data?.full_name,
        brandName: data?.brand_name || "",
        firstName: data?.first_name,
        lastName: data?.last_name,
        logoUrl: data?.logo_url,
        // isActive: data?.is_active,
        percentage: data?.percentage,
        logout_time: data?.logout_time,
        referral_notification_id: data?.referral_notification_id || 3,
        verification_workflow_id: data?.verification_workflow_id || null,
        address: {
          poBox: data?.number || "",
          street: data?.street || "",
          city: data?.city || "",
          state: data?.state || "",
          zipcode: data?.zipcode || "",
          country: "US",
        },
        contact: {
          email: data?.email || "",
          phoneNumber: data?.phone_number || "",
        },
        mainContact: {
          firstName: data?.main_contact?.first_name || "",
          lastName: data?.main_contact?.last_name || "",
          email: data?.main_contact?.email || "",
          phoneNumber: data?.main_contact?.phone_number || "",
        },
        subscription: {
          cost: data?.subscriptions[0]?.cost,
          limit: data?.subscriptions[0]?.limit,
          overage: data?.subscriptions[0]?.overage_cost,
          payload: data?.subscriptions[0]?.payload,
          quote_cost: data?.subscriptions[0]?.quote_cost,
        },
        dealershipTiming:
          data?.dealershipTiming?.length > 0
            ? data.dealershipTiming.map((timing) => ({
                id: parseInt(timing?.id),
                day: timing?.day,
                opens_at: timing?.opens_at,
                closes_at: timing?.closes_at,
                isclosed: timing?.isclosed,
              }))
            : [],
        services: mergedServices || [],
      });
    }
  }, [data]);

  const { data: SearchData } = useQuery(SEARCH_MANAGER, {
    variables: {
      searchInput: {
        dealership_id: null,
        email: null,
      },
    },
    skip: edit,
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });
  const [manageAssociation, { data: associateManager }] =
    useMutation(MANAGE_ASSOCIATION);
  const [createUser, { data: User }] = useMutation(CREATE_USER);

  const { data: SearchPatners, refetch } = useQuery(SEARCH_PATNERS, {
    variables: {
      selectedInput: {
        patner_name: "",
      },
    },
    skip: edit,
  });

  useEffect(() => {
    if (SearchPatners && SearchPatners?.searchPatners?.getPatnerId) {
      setDealer({
        ...dealer,
        patner_id: parseInt(SearchPatners?.searchPatners?.getPatnerId),
      });
    }
  }, [SearchPatners]);

  const createDealerHandler = () => {
    manageDealership({
      variables: {
        dealershipInput: {
          main_contact: {
            first_name: dealer.mainContact.firstName,
            last_name: dealer.mainContact.lastName,
            email: dealer.mainContact.email,
            phone_number: dealer.mainContact.phoneNumber,
          },
          subscription: {
            dealership_id: null,
            cost: dealer.subscription.cost,
            limit: dealer.subscription.limit,
            overage_cost: dealer.subscription.overage,
            payload: dealer.subscription.payload,
            quote_cost: dealer.subscription.quote_cost,
          },
          dealership_name: dealer.dealershipName,
          brand_name: dealer.brandName,
          first_name: dealer.firstName,
          last_name: dealer.lastName,
          // is_active: dealer?.isActive,
          logo_url: selectedImage,
          role: "dealership",
          email: dealer.contact.email,
          phone_number: dealer.contact.phoneNumber,
          number: dealer.address.poBox,
          street: dealer.address.street,
          city: dealer.address.city,
          state: dealer.address.state,
          zipcode: dealer.address.zipcode,
          percentage: dealer?.percentage,
          logout_time: dealer?.logout_time,
          referral_notification_id: dealer?.referral_notification_id ,
          verification_workflow_id: dealer?.verification_workflow_id,

          patner_name: dealer?.patner_name,
          patner_id: dealer?.patner_id,
          created_by: auth?.user?.user_id,
          updated_by: auth?.user?.user_id,
          dealershipTimings: dealer.dealershipTiming,
          services: dealer.services,
        },
      },
    }).then((data) => {
      console.log("success");

      if (props.onSuccess) {
        props.onSuccess();
      }
    });
  };
  const editDealerHandler = () => {
    manageDealership({
      variables: {
        dealershipInput: {
          main_contact: {
            first_name: dealer?.mainContact?.firstName,
            last_name: dealer.mainContact.lastName,
            email: dealer.mainContact.email,
            phone_number: dealer.mainContact.phoneNumber,
          },
          subscription: {
            dealership_id: parseInt(params.dealershipId),
            cost: dealer.subscription.cost,
            limit: dealer.subscription.limit,
            overage_cost: dealer.subscription.overage,
            payload: dealer.subscription.payload,
            quote_cost: dealer?.subscription?.quote_cost,
          },
          dealership_id: parseInt(params.dealershipId),
          dealership_name: dealer.dealershipName,
          brand_name: dealer.brandName,
          // is_active: dealer.isActive,
          logo_url: selectedImage,
          role: "dealership",
          email: dealer.contact.email,
          phone_number: dealer.contact.phoneNumber,
          number: dealer.address.poBox,
          street: dealer.address.street,
          city: dealer.address.city,
          state: dealer.address.state,
          zipcode: dealer.address.zipcode,
          percentage: dealer?.percentage,
          verification_workflow_id: dealer?.verification_workflow_id,
          logout_time: dealer?.logout_time,
          referral_notification_id: dealer?.referral_notification_id,
          created_by: auth?.user?.user_id,
          updated_by: auth?.user?.user_id,
          dealershipTimings: dealer.dealershipTiming,
          services: dealer?.services,
        },
      },
    }).then(() => {
      showSuccess();
      refetch();
      refetchdealer?.();
    });
  };
  const showSuccess = () => {
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 5000);
  };
  const addUsersHandler = (dealershipId) => {
    newUsers.map(async (user) => {
      await createUser({
        variables: {
          createUserInput: {
            first_name: user.firstName,
            last_name: user.lastName,
            middle_name: "",
            email: user.email,
            mobile_number: user.phoneNumber.replace(/\D/g, ""),
            role: user.designation,
            verification_preference: user.verifyNotification,
            appointment_preference: user.appointmentNotification,
            review_preference: user.reviewNotification,
            referral_preference: user.referralNotification,
            notification_preference: user.receiveNotification,
            // current_target: 0,
            created_by: 0,
            updated_by: 0,
            dealership_id: parseInt(dealershipId),
            employee_user_id: null,
            d_startDate: firstOfMonth,
            d_endDate: today,
            f_startDate: firstOfMonth,
            f_endDate: today,
            timezone: new Date().getTimezoneOffset(),
            verification_workflow_id: user?.verification_workflow_id,
            isAdmin: true,
          },
        },
      });
    });
  };

  const associateUsersHandler = (dealershipId) => {
    newAssociates.map(async (email) => {
      await manageAssociation({
        variables: {
          associateInput: {
            dealership_id: dealershipId,
            email: email,
            associate: true,
            d_startDate: firstOfMonth,
            d_endDate: today,
            timezone: new Date().getTimezoneOffset(),
            isAdmin: true,
          },
        },
      });
    });
  };

  const [manageDealership, { loading: updateLoading, data: Dealership }] =
    useMutation(MANAGE_DEALERSHIP, {
      onCompleted: async (data) => {
        if (data?.manageDealership?.dealership_id && !edit) {
          addUsersHandler(data?.manageDealership?.dealership_id);
          associateUsersHandler(data?.manageDealership?.dealership_id);
          crmUpdateHandler(data?.manageDealership?.dealership_id);
          app.setDealershipId(data?.manageDealership?.dealership_id);
          setValue(1);
          navigate(
            `/createDealership/${data?.manageDealership?.dealership_id}/artifacts`,
          );
        } else {
          console.log("error creating dealership");
        }
      },
    });

  const [manageCrmUser] = useMutation(MANAGE_CRM_USERS);

  const crmUpdateHandler = (did) => {
    manageCrmUser({
      variables: {
        crmInput: {
          dealership_id: did,
          crm_user_status: checked,
        },
      },
    });
  };

  const mainContactHandler = () => {
    setShowMainContact(!showMainContact);
  };

  const switchUsersTab = (args) => {
    setAssociate(args === "associate" ? true : false);
  };

  const handleChipDelete = (chipToDelete) => {
    setNewUsers((prevChips) =>
      prevChips.filter((chip) => chip.firstName !== chipToDelete.firstName),
    );
    setNewAssociates((prevState) =>
      prevState.filter((email) => email !== chipToDelete),
    );
  };

  const loadNewUser = (user, associate) => {
    if (user) setNewUsers((prevChips) => [...prevChips, user]);
    if (associate) {
      setNewAssociates((prevState) => [...prevState, associate]);
    }
  };
  useEffect(() => {
    if (Dealership) {
      setDealer({
        dealershipName: "",
        brandName: "",
        firstName: "",
        lastName: "",
        logoUrl: "",
        // isActive: "",
        percentage: "",
        logout_time: 30,
        referral_notification_id: 3,
        //  verification_workflow_id: 1,
        patner_name: "",
        patner_id: 0,
        address: {
          poBox: "",
          street: "",
          city: "",
          state: "",
          zipcode: "",
          country: "US",
        },
        contact: {
          email: "",
          phoneNumber: "",
        },
        mainContact: {
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
        },
        subscription: {
          cost: "0",
          limit: "0",
          overage: "0",
          payload: 2,
          quote_cost: "0",
        },
        manager_employee: {
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
          designation: "employee",
          verifyNotification: 3,
          appointmentNotification: 3,
          reviewNotification: 3,
          
          receiveNotification: 3,
          verification_workflow_id: 1,
        },
        dealershipTiming:
          weekDays.map((day) => ({
            day,
            opens_at: "09:00",
            closes_at: "21:00",
            isclosed: false,
          })) || [],
      });
      setNewUsers("");
      setNewAssociates("");
      setAssociate("");
      setSelectedImage(null);
    }
  }, [Dealership]);

  const handleStateChange = (event, newValue) => {
    if (newValue) {
      setDealer({
        ...dealer,
        address: {
          ...dealer.address,
          state: newValue.label,
        },
      });
    }
  };

  const crmSwitchHandle = (event) => {
    setChecked(event.target.checked);
  };

  const inputRef = useRef();

  const [image, setImage] = useState("");

  const handleClose = () => {
    setImage("");
    setIsOpen(false);
  };
  const onImageSelected = (selectedImg) => {
    setImage(selectedImg);
    setIsOpen(true);
  };

  const onCropCancel = () => {
    handleClose();
  };
  const onCropDone = (image) => {
    setSelectedImage(image);
    handleClose();
  };
  const handleOnChange = (event) => {
    setImage("");

    if (event.target.files && event.target.files.length > 0) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = function (e) {
        onImageSelected(reader.result);
      };
    } else {
      setSelectedImage(null);
      handleClose();
    }
  };
  const onChooseImg = () => {
    if (inputRef.current) {
      inputRef.current.value = null;
    }
    inputRef.current.click();
  };

  useEffect(() => {
    dialog({
      open: isOpen,
      bodyType: TYPE.UPLOAD_LOGO,
      body: (
        <ImageCropper
          image={image}
          onCropDone={onCropDone}
          onCropCancel={onCropCancel}
        />
      ),
      maxWidth: "md",
    });
  }, [image]);

  console.log("DealershipFormmmmm", dealer);
  return (
    <Box
      ref={props?.ref}
      sx={DialogStyle.MainBox}
      width={"100%"}
      height={"100%"}
    >
      <Box>
        <Typography variant="h6">Dealership Details</Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          overflow: "scroll",
          pt: 1,
        }}
      >
        <Box sx={DialogStyle.dealershipBox}>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
              <TextField
                label="Dealership Name *"
                sx={{ width: "50%" }}
                color={
                  InputValidation.nameValidation(dealer.dealershipName)
                    ? "error"
                    : "primary"
                }
                value={dealer.dealershipName}
                error={InputValidation.nameValidation(dealer.dealershipName)}
                onChange={(event) =>
                  setDealer({ ...dealer, dealershipName: event.target.value })
                }
                helperText={
                  InputValidation.nameValidation(dealer.dealershipName)
                    ? "Please enter a valid name"
                    : " "
                }
              />

<FormControl variant="outlined" sx={{ width: "50%" }}>
  <Autocomplete
    options={brandNameOptions}
    value={dealer.brandName || null}
    loading={makesLoading}
    disabled={makesLoading}
    onChange={(event, newValue) =>
      setDealer({ ...dealer, brandName: newValue || "" })
    }
    isOptionEqualToValue={(option, value) => option === value}
    renderInput={(params) => (
      <TextField {...params} label="Brand Name" />
    )}
  />
  <FormHelperText> </FormHelperText>
</FormControl>
            </Box>

            <Box sx={DialogStyle.emailWidth}>
              <FormControl variant="outlined" sx={DialogStyle.width}>
                <InputLabel>P.O. Box</InputLabel>
                <OutlinedInput
                  required
                  label="P.O. Box"
                  value={dealer.address.poBox}
                  error={InputValidation.addressValidation(
                    dealer.address.poBox,
                  )}
                  onChange={(event) =>
                    setDealer({
                      ...dealer,
                      address: {
                        ...dealer?.address,
                        poBox: event.target.value,
                      },
                    })
                  }
                />
                <FormHelperText sx={{ color: theme.palette.error.main }}>
                  {InputValidation.addressValidation(dealer.address.poBox)
                    ? "Please enter a valid P.o. Box"
                    : " "}
                </FormHelperText>
              </FormControl>
              <FormControl variant="outlined" sx={DialogStyle.width}>
                <InputLabel
                  color={
                    InputValidation.addressValidation(dealer.address.city)
                      ? "error"
                      : "primary"
                  }
                >
                  Street*
                </InputLabel>
                <OutlinedInput
                  required
                  label="Street"
                  value={dealer.address.street}
                  error={InputValidation.addressValidation(
                    dealer.address.street,
                  )}
                  onChange={(event) =>
                    setDealer({
                      ...dealer,
                      address: {
                        ...dealer.address,
                        street: event.target.value,
                      },
                    })
                  }
                />
                <FormHelperText sx={{ color: theme.palette.error.main }}>
                  {InputValidation.addressValidation(dealer.address.street)
                    ? "Please enter a valid street"
                    : " "}
                </FormHelperText>
              </FormControl>
              <FormControl variant="outlined" sx={DialogStyle.width}>
                <InputLabel
                  color={
                    InputValidation.addressValidation(dealer.address.city)
                      ? "error"
                      : "primary"
                  }
                >
                  City*
                </InputLabel>
                <OutlinedInput
                  required
                  label="City"
                  value={dealer.address.city}
                  error={InputValidation.addressValidation(dealer.address.city)}
                  onChange={(event) =>
                    setDealer({
                      ...dealer,
                      address: {
                        ...dealer.address,
                        city: event.target.value,
                      },
                    })
                  }
                />
                <FormHelperText sx={{ color: theme.palette.error.main }}>
                  {InputValidation.addressValidation(dealer.address.city)
                    ? "Please enter a valid city"
                    : " "}
                </FormHelperText>
              </FormControl>
            </Box>

            <Box sx={DialogStyle.emailWidth}>
              <FormControl variant="outlined" sx={DialogStyle.width}>
                <Autocomplete
                  options={states}
                  value={dealer.address.state}
                  onChange={handleStateChange}
                  renderInput={(params) => {
                    return <TextField {...params} label="State" />;
                  }}
                />
                <FormHelperText sx={{ color: theme.palette.error.main }}>
                  {InputValidation.addressValidation(dealer.address.state)
                    ? "Please enter a valid state"
                    : " "}
                </FormHelperText>
              </FormControl>
              <FormControl
                variant="outlined"
                sx={DialogStyle.width}
                margin="1px"
              >
                <InputLabel
                  color={
                    InputValidation.zipCodeValidation(dealer.address.zipcode)
                      ? "error"
                      : "primary"
                  }
                >
                  Zipcode*
                </InputLabel>
                <OutlinedInput
                  required
                  label="Zipcode"
                  type="number"
                  value={dealer.address.zipcode}
                  error={InputValidation.zipCodeValidation(
                    dealer.address.zipcode,
                  )}
                  onChange={(event) =>
                    setDealer({
                      ...dealer,
                      address: {
                        ...dealer.address,
                        zipcode: event.target.value,
                      },
                    })
                  }
                />
                <FormHelperText sx={{ color: theme.palette.error.main }}>
                  {InputValidation.zipCodeValidation(dealer.address.zipcode)
                    ? "Please enter a valid zipcode"
                    : " "}
                </FormHelperText>
              </FormControl>
              <FormControl variant="outlined" sx={DialogStyle.width} disabled>
                <InputLabel
                  color={
                    InputValidation.nameValidation(dealer.address.country)
                      ? "error"
                      : "primary"
                  }
                >
                  Country
                </InputLabel>
                <OutlinedInput
                  required
                  label="Country"
                  value={dealer.address.country}
                />
              </FormControl>
            </Box>
          </Box>
          {/* imagePlace */}
          <Box sx={DialogStyle.imageBox}>
            {!edit ? (
              <>
                {selectedImage || dealer?.logoUrl ? (
                  <>
                    <img
                      src={selectedImage || dealer?.logoUrl || noImage}
                      width={120}
                      alt="logo"
                    />
                    <Button
                      onClick={() => {
                        setSelectedImage(null);
                      }}
                    >
                      Remove
                    </Button>
                  </>
                ) : (
                  <>
                    <label htmlFor="raised-button-file">
                      <Box sx={DialogStyle.withoutImage}>
                        <SvgIcon
                          component={AddPhotoAlternateOutlined}
                          width={120}
                          height={120}
                        />

                        <Box>
                          <input
                            type="file"
                            accept="image/*"
                            ref={inputRef}
                            onChange={handleOnChange}
                            style={{ display: "none" }}
                          />
                          <Button
                            variant="raised"
                            color="primary"
                            component="span"
                            onClick={onChooseImg}
                          >
                            Upload
                          </Button>
                        </Box>
                      </Box>
                    </label>
                  </>
                )}
              </>
            ) : (
              <>
                <img
                  src={selectedImage || dealer?.logoUrl || noImage}
                  width={120}
                  alt="logo"
                />
                <Box>
                  <input
                    type="file"
                    accept="image/*"
                    ref={inputRef}
                    onChange={(e) => {
                      console.log("eventtonchange");
                      handleOnChange(e);
                      e.target.files = null;
                    }}
                    style={{ display: "none" }}
                  />
                  <Button
                    variant="raised"
                    color="primary"
                    component="span"
                    onClick={onChooseImg}
                  >
                    Upload
                  </Button>
                </Box>
              </>
            )}
          </Box>
        </Box>
        <Box sx={DialogStyle.emailWidth}>
          <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
            <InputLabel
              color={
                InputValidation.emailValidation(dealer.contact.email)
                  ? "error"
                  : "primary"
              }
            >
              Email *
            </InputLabel>
            <OutlinedInput
              required
              label="Email"
              value={dealer.contact.email}
              onChange={(event) =>
                setDealer({
                  ...dealer,
                  contact: {
                    ...dealer.contact,
                    email: event.target.value,
                  },
                })
              }
              error={InputValidation.emailValidation(dealer.contact.email)}
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.emailValidation(dealer.contact.email)
                ? "Please enter a valid email"
                : " "}
            </FormHelperText>
          </FormControl>
          <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
            <InputLabel
              color={
                InputValidation.numberValidation(dealer.contact.phoneNumber)
                  ? "error"
                  : "primary"
              }
            >
              Phone Number *
            </InputLabel>
            <OutlinedInput
              required
              label="Phone Number"
              value={InputValidation.phoneNumberFormat(
                dealer.contact.phoneNumber,
              )}
              type="tel"
              onChange={(event) =>
                setDealer({
                  ...dealer,
                  contact: {
                    ...dealer.contact,
                    phoneNumber: event.target.value,
                  },
                })
              }
              error={InputValidation.numberValidation(
                dealer.contact.phoneNumber,
              )}
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.numberValidation(dealer.contact.phoneNumber)
                ? "Please enter a valid contact number"
                : " "}
            </FormHelperText>
          </FormControl>
        </Box>
        <Box sx={DialogStyle.emailWidth}>
          <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
            <InputLabel id="demo-simple-select-label">Workflow</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={
                edit
                  ? dealer.verification_workflow_id
                  : dealer?.manager_employee?.verification_workflow_id
              }
              label="Workflow"
              onChange={(e) => {
                if (edit) {
                  setDealer({
                    ...dealer,
                    verification_workflow_id: e.target.value,
                  });
                } else {
                  setDealer({
                    ...dealer,
                    manager_employee: {
                      ...dealer.manager_employee,
                      verification_workflow_id: e.target.value,
                    },
                  });
                }
              }}
            >
              <MenuItem value={1}>Verify & Offer Quote</MenuItem>
              <MenuItem value={2}>Verify Only</MenuItem>
              <MenuItem value={3}>Offer Quote Only</MenuItem>
            </Select>
          </FormControl>

          <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
            <Autocomplete
              options={options}
              getOptionLabel={(option) => option.toString()}
              isOptionEqualToValue={(option, value) => option === value}
              value={dealer?.percentage}
              onChange={(e, newValue) => {
                setDealer({
                  ...dealer,
                  percentage: newValue,
                });
              }}
              renderInput={(params) => {
                return <TextField {...params} label="Percentage of Savings" />;
              }}
            />
          </FormControl>

          <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
            <Autocomplete
              options={logoutoptions}
              getOptionLabel={(option) => option}
              isOptionEqualToValue={(option, value) => option === value}
              value={dealer?.logout_time}
              onChange={(e, newValue) => {
                setDealer({
                  ...dealer,
                  logout_time: newValue,
                });
              }}
              renderInput={(params) => {
                return <TextField {...params} label="Auto Logout time" />;
              }}
            />
          </FormControl>
          <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
            <InputLabel>Referral Notification</InputLabel>
            <Select
              value={dealer.referral_notification_id}
              label="Referral Notification"
              disabled={associate}
              onChange={(e) => {
                setDealer({
                  ...dealer,
                  referral_notification_id: e.target.value,
                });
              }}
            >
              <MenuItem value={3}>None</MenuItem>
              <MenuItem value={1}>Email</MenuItem>
              <MenuItem value={2}>Text</MenuItem>
            </Select>
          </FormControl>
        </Box>
        { !edit && (
          <Box sx={DialogStyle.emailWidth}>
            <Switch
              sx={{ mt: 3 }}
              // checked={checked}
              size="small"
              onChange={crmSwitchHandle}
              // inputProps={{ "aria-label": "ant design" }}
            />
            <Typography sx={{ width: "40%", mt: 3 }}>
              CRM User Enabled
            </Typography>

            <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
              <Autocomplete
                options={SearchPatners?.searchPatners?.getAllPatners || []}
                disabled={dealer.patner_name}
                onChange={(e, newValue) => {
                  refetch({
                    selectedInput: {
                      patner_name: `${newValue}`,
                    },
                  });
                }}
                renderInput={(params) => {
                  return <TextField {...params} label="Select Partner" />;
                }}
              />
            </FormControl>

            <Typography style={{ marginTop: "25px" }}>OR</Typography>

            <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
              <InputLabel
                color={
                  InputValidation.nameValidation(dealer.patner_name)
                    ? "error"
                    : "primary"
                }
              >
                Enter Partner Name
              </InputLabel>
              <OutlinedInput
                required
                label="Enter Partner Name"
                value={dealer.patner_name}
                error={InputValidation.nameValidation(dealer.patner_name)}
                disabled={SearchPatners?.searchPatners?.getPatnerId}
                onChange={(event) =>
                  setDealer({
                    ...dealer,
                    patner_name: event.target.value,
                  })
                }
              />
              <FormHelperText sx={{ color: theme.palette.error.main }}>
                {InputValidation.nameValidation(dealer.patner_name)
                  ? "Please enter a valid patner name"
                  : " "}
              </FormHelperText>
            </FormControl>
          </Box>
        )}

        {/* Main Contact*/}
        <Box sx={DialogStyle.mainContactBox}>
          <Typography variant="h6">Main Contact</Typography>
          <IconButton onClick={mainContactHandler}>
            {!showMainContact ? (
              <AddCircleOutlineOutlined />
            ) : (
              <RemoveCircleOutline />
            )}
          </IconButton>
        </Box>
        {showMainContact && (
          <>
            <Box sx={DialogStyle.emailWidth}>
              <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
                <InputLabel
                  color={
                    InputValidation.nameValidation(dealer.mainContact.firstName)
                      ? "error"
                      : "primary"
                  }
                >
                  First Name
                </InputLabel>
                <OutlinedInput
                  required
                  label="First Name"
                  value={dealer.mainContact.firstName}
                  error={InputValidation.nameValidation(
                    dealer.mainContact.firstName,
                  )}
                  onChange={(event) =>
                    setDealer({
                      ...dealer,
                      mainContact: {
                        ...dealer.mainContact,
                        firstName: event.target.value,
                      },
                    })
                  }
                />
                <FormHelperText sx={{ color: theme.palette.error.main }}>
                  {InputValidation.nameValidation(dealer.mainContact.firstName)
                    ? "Please enter a valid name"
                    : " "}
                </FormHelperText>
              </FormControl>
              <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
                <InputLabel
                  color={
                    InputValidation.nameValidation(dealer.mainContact.lastName)
                      ? "error"
                      : "primary"
                  }
                >
                  Last Name
                </InputLabel>
                <OutlinedInput
                  required
                  label="Last Name"
                  value={dealer.mainContact.lastName}
                  error={InputValidation.nameValidation(
                    dealer.mainContact.lastName,
                  )}
                  onChange={(event) =>
                    setDealer({
                      ...dealer,
                      mainContact: {
                        ...dealer.mainContact,
                        lastName: event.target.value,
                      },
                    })
                  }
                />
                <FormHelperText sx={{ color: theme.palette.error.main }}>
                  {InputValidation.nameValidation(dealer.mainContact.lastName)
                    ? "Please enter a valid name"
                    : " "}
                </FormHelperText>
              </FormControl>
            </Box>
            <Box sx={DialogStyle.emailWidth}>
              <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
                <InputLabel
                  color={
                    InputValidation.emailValidation(dealer.mainContact.email)
                      ? "error"
                      : "primary"
                  }
                >
                  Email
                </InputLabel>
                <OutlinedInput
                  required
                  label="Email"
                  type="email"
                  value={dealer.mainContact.email}
                  onChange={(event) =>
                    setDealer({
                      ...dealer,
                      mainContact: {
                        ...dealer.mainContact,
                        email: event.target.value,
                      },
                    })
                  }
                  error={InputValidation.emailValidation(
                    dealer.mainContact.email,
                  )}
                />
                <FormHelperText sx={{ color: theme.palette.error.main }}>
                  {InputValidation.emailValidation(dealer.mainContact.email)
                    ? "Please enter a valid email"
                    : " "}
                </FormHelperText>
              </FormControl>
              <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
                <InputLabel
                  color={
                    InputValidation.numberValidation(
                      dealer.mainContact.phoneNumber,
                    )
                      ? "error"
                      : "primary"
                  }
                >
                  Contact Number
                </InputLabel>
                <OutlinedInput
                  required
                  label="Contact Number"
                  value={InputValidation.phoneNumberFormat(
                    dealer.mainContact.phoneNumber,
                  )}
                  type="tel"
                  onChange={(event) =>
                    setDealer({
                      ...dealer,
                      mainContact: {
                        ...dealer.mainContact,
                        phoneNumber: event.target.value,
                      },
                    })
                  }
                  error={InputValidation.numberValidation(
                    dealer.mainContact.phoneNumber,
                  )}
                />
                <FormHelperText sx={{ color: theme.palette.error.main }}>
                  {InputValidation.numberValidation(
                    dealer.mainContact.phoneNumber,
                  )
                    ? "Please enter a valid contact number"
                    : " "}
                </FormHelperText>
              </FormControl>
            </Box>
          </>
        )}
        {/* Manager/employee */}
        {!edit && (
          <>
            <Divider />
            <Typography variant="h6">Manager / Employee </Typography>
            <Box sx={DialogStyle.associatebutton}>
              <AppButton
                buttonText="Create"
                variant={associate ? "outlined" : "contained"}
                sx={{ width: "100%" }}
                clickHandler={() => switchUsersTab("create")}
              />
              <AppButton
                buttonText="Associate"
                variant={associate ? "contained" : "outlined"}
                sx={{ width: "100%" }}
                clickHandler={() => switchUsersTab("associate")}
              />
            </Box>
            <Box sx={DialogStyle.managerBox}>
              <Box width={"73%"}>
                <Box sx={DialogStyle.emailWidth}>
                  {!associate ? (
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel
                        color={
                          InputValidation.nameValidation(
                            dealer?.manager_employee?.firstName,
                          )
                            ? "error"
                            : "primary"
                        }
                      >
                        First Name *
                      </InputLabel>
                      <OutlinedInput
                        required
                        label="First Name"
                        value={dealer?.manager_employee?.firstName}
                        error={InputValidation.nameValidation(
                          dealer?.manager_employee?.firstName,
                        )}
                        onChange={(event) =>
                          setDealer({
                            ...dealer,
                            manager_employee: {
                              ...dealer.manager_employee,
                              firstName: event.target.value,
                            },
                          })
                        }
                      />
                      <FormHelperText sx={{ color: theme.palette.error.main }}>
                        {InputValidation.nameValidation(
                          dealer?.manager_employee.firstName,
                        )
                          ? "Please enter a valid firstName"
                          : " "}
                      </FormHelperText>
                    </FormControl>
                  ) : (
                    <Autocomplete
                      disablePortal
                      autoComplete
                      options={[
                        ...(SearchData?.searchManager?.getAllEmails || []),
                      ].sort((a, b) => a?.localeCompare(b))}
                      sx={{ width: "25vw" }}
                      onChange={(event, newValue) =>
                        setAssociateEmail(newValue)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Search Manager / Employee Email ID*"
                        />
                      )}
                    />
                  )}

                  <FormControl
                    variant="outlined"
                    fullWidth
                    disabled={associate}
                  >
                    <InputLabel
                      color={
                        InputValidation.nameValidation(
                          dealer.manager_employee.lastName,
                        )
                          ? "error"
                          : "primary"
                      }
                    >
                      Last Name *
                    </InputLabel>
                    <OutlinedInput
                      required
                      label="Last Name *"
                      value={dealer.manager_employee.lastName}
                      error={InputValidation.nameValidation(
                        dealer.manager_employee.lastName,
                      )}
                      onChange={(event) =>
                        setDealer({
                          ...dealer,
                          manager_employee: {
                            ...dealer.manager_employee,
                            lastName: event.target.value,
                          },
                        })
                      }
                    />
                    <FormHelperText sx={{ color: theme.palette.error.main }}>
                      {InputValidation.nameValidation(
                        dealer.manager_employee.lastName,
                      )
                        ? "Please enter a valid name"
                        : " "}
                    </FormHelperText>
                  </FormControl>
                </Box>

                <Box sx={DialogStyle.emailWidth}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    // sx={{ width: "25vw" }}
                    disabled={associate}
                  >
                    <InputLabel
                      color={
                        InputValidation.emailValidation(
                          dealer.manager_employee.email,
                        )
                          ? "error"
                          : "primary"
                      }
                    >
                      Email *
                    </InputLabel>
                    <OutlinedInput
                      required
                      label="Email *"
                      type="email"
                      value={dealer.manager_employee.email}
                      onChange={(event) =>
                        setDealer({
                          ...dealer,
                          manager_employee: {
                            ...dealer.manager_employee,
                            email: event.target.value,
                          },
                        })
                      }
                      error={InputValidation.emailValidation(
                        dealer.manager_employee.email,
                      )}
                    />
                    <FormHelperText sx={{ color: theme.palette.error.main }}>
                      {InputValidation.emailValidation(
                        dealer.manager_employee.email,
                      )
                        ? "Please enter a valid email"
                        : " "}
                    </FormHelperText>
                  </FormControl>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    // sx={{ width: "25vw" }}
                    disabled={associate}
                  >
                    <InputLabel
                      color={
                        InputValidation.numberValidation(
                          dealer.manager_employee.phoneNumber,
                        )
                          ? "error"
                          : "primary"
                      }
                    >
                      Phone Number *
                    </InputLabel>
                    <OutlinedInput
                      required
                      label="Phone Number *"
                      value={InputValidation.phoneNumberFormat(
                        dealer.manager_employee.phoneNumber,
                      )}
                      type="tel"
                      onChange={(event) =>
                        setDealer({
                          ...dealer,
                          manager_employee: {
                            ...dealer.manager_employee,
                            phoneNumber: event.target.value,
                          },
                        })
                      }
                      error={InputValidation.numberValidation(
                        dealer.manager_employee.phoneNumber,
                      )}
                    />
                    <FormHelperText sx={{ color: theme.palette.error.main }}>
                      {InputValidation.numberValidation(
                        dealer.manager_employee.phoneNumber,
                      )
                        ? "Please enter a valid contact number"
                        : " "}
                    </FormHelperText>
                  </FormControl>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      Designation
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={dealer.manager_employee.designation}
                      label="Designation"
                      disabled={associate}
                      onChange={(e) => {
                        setDealer({
                          ...dealer,
                          manager_employee: {
                            ...dealer.manager_employee,
                            designation: e.target.value,
                          },
                        });
                      }}
                    >
                      <MenuItem value={"manager"}>Manager</MenuItem>
                      <MenuItem value={"employee"}>Employee</MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                <Box sx={DialogStyle.emailWidth}>
                  <FormControl fullWidth>
                    <InputLabel
                    // id="demo-simple-select-label"
                    >
                      Verify Notification
                    </InputLabel>
                    <Select
                      // labelId="demo-simple-select-label"
                      // id="demo-simple-select"
                      value={dealer.manager_employee.verifyNotification}
                      label="Verify Notification"
                      disabled={associate}
                      onChange={(e) => {
                        setDealer({
                          ...dealer,
                          manager_employee: {
                            ...dealer.manager_employee,
                            verifyNotification: e.target.value,
                          },
                        });
                      }}
                    >
                      <MenuItem value={3}>None</MenuItem>
                      <MenuItem value={1}>Email</MenuItem>
                      <MenuItem value={2}>Text</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl fullWidth>
                    <InputLabel
                    // id="demo-simple-select-label"
                    >
                      Quote Notification
                    </InputLabel>
                    <Select
                      // labelId="demo-simple-select-label"
                      // id="demo-simple-select"
                      value={dealer.manager_employee.receiveNotification}
                      label="Quote Notification"
                      disabled={associate}
                      onChange={(e) => {
                        setDealer({
                          ...dealer,
                          manager_employee: {
                            ...dealer.manager_employee,
                            receiveNotification: e.target.value,
                          },
                        });
                      }}
                    >
                      <MenuItem value={3}>None</MenuItem>
                      <MenuItem value={1}>Email</MenuItem>
                      <MenuItem value={2}>Text</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl fullWidth>
                    <InputLabel>Appointment Notification</InputLabel>
                    <Select
                      value={dealer.manager_employee.appointmentNotification}
                      label="Appointment Notification"
                      disabled={associate}
                      onChange={(e) => {
                        setDealer({
                          ...dealer,
                          manager_employee: {
                            ...dealer.manager_employee,
                            appointmentNotification: e.target.value,
                          },
                        });
                      }}
                    >
                      <MenuItem value={3}>None</MenuItem>
                      <MenuItem value={1}>Email</MenuItem>
                      <MenuItem value={2}>Text</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl fullWidth>
                    <InputLabel>Review Followup Notification</InputLabel>
                    <Select
                      value={dealer.manager_employee.reviewNotification}
                      label="Review Followup Notification"
                      disabled={associate}
                      onChange={(e) => {
                        setDealer({
                          ...dealer,
                          manager_employee: {
                            ...dealer.manager_employee,
                            reviewNotification: e.target.value,
                          },
                        });
                      }}
                    >
                      <MenuItem value={3}>None</MenuItem>
                      <MenuItem value={1}>Email</MenuItem>
                      <MenuItem value={2}>Text</MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                <AppButton
                  buttonText="Add Manager / Employee"
                  variant="outlined"
                  sx={{ width: "100%", marginTop: "16px" }}
                  disabled={
                    associate
                      ? false
                      : dealer.manager_employee.firstName == "" ||
                        dealer.manager_employee.lastName == ""
                  }
                  clickHandler={() =>
                    associate
                      ? loadNewUser(null, associateEmail)
                      : loadNewUser(dealer.manager_employee, null)
                  }
                />
              </Box>
              <Box sx={DialogStyle.associateBox}>
                <Typography variant="body2">Users</Typography>
                <Box sx={DialogStyle.chipBox}>
                  {newUsers.length > 0
                    ? [...new Set(newUsers)].map((chip) => (
                        <Chip
                          icon={<Group />}
                          label={chip.firstName}
                          onDelete={() => handleChipDelete(chip)}
                          variant="outlined"
                          color="primary"
                          sx={DialogStyle.chip}
                        />
                      ))
                    : "-- No new users"}
                </Box>
                <Typography variant="body2">Associations</Typography>
                <Box sx={DialogStyle.chipBox}>
                  {newAssociates.length > 0
                    ? [...new Set(newAssociates)].map((chip) => (
                        <Chip
                          icon={<Group />}
                          label={chip}
                          onDelete={() => handleChipDelete(chip)}
                          variant="outlined"
                          color="primary"
                          sx={DialogStyle.chip}
                        />
                      ))
                    : "-- No users to associate"}
                </Box>
              </Box>
            </Box>
          </>
        )}

        <Divider />

        <Typography variant="h6">API Subscription</Typography>
        <Box sx={DialogStyle.emailWidth}>
          <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
            <InputLabel
              color={
                InputValidation.negativeValidation(dealer.subscription.cost)
                  ? "error"
                  : "primary"
              }
            >
              Subscription Cost
            </InputLabel>
            <OutlinedInput
              required
              label="Subscription Cost"
              type="number"
              value={dealer.subscription.cost}
              error={InputValidation.negativeValidation(
                dealer.subscription.cost,
              )}
              inputProps={{ min: 0 }}
              onChange={(event) =>
                setDealer({
                  ...dealer,
                  subscription: {
                    ...dealer.subscription,
                    cost: event.target.value,
                  },
                })
              }
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.negativeValidation(dealer.subscription.cost)
                ? "Please enter a valid subscription cost"
                : " "}
            </FormHelperText>
          </FormControl>
          <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
            <InputLabel
              color={
                InputValidation.negativeValidation(dealer.subscription.limit)
                  ? "error"
                  : "primary"
              }
            >
              Max Pull
            </InputLabel>
            <OutlinedInput
              required
              label="Max Pull"
              value={dealer.subscription.limit}
              error={InputValidation.negativeValidation(
                dealer.subscription.limit,
              )}
              type="number"
              onChange={(event) =>
                setDealer({
                  ...dealer,
                  subscription: {
                    ...dealer.subscription,
                    limit: event.target.value,
                  },
                })
              }
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.negativeValidation(dealer.subscription.limit)
                ? "Please enter a valid max pull"
                : " "}
            </FormHelperText>
          </FormControl>
          <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
            <InputLabel
              color={
                InputValidation.negativeValidation(
                  dealer.subscription?.quote_cost,
                )
                  ? "error"
                  : "primary"
              }
            >
              Request Quote Cost
            </InputLabel>
            <OutlinedInput
              required
              label="Request Quote Cost"
              type="number"
              value={dealer.subscription?.quote_cost}
              error={InputValidation.negativeValidation(
                dealer.subscription.quote_cost,
              )}
              inputProps={{ min: 0 }}
              onChange={(event) =>
                setDealer({
                  ...dealer,
                  subscription: {
                    ...dealer.subscription,
                    quote_cost: event.target.value,
                  },
                })
              }
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.negativeValidation(
                dealer.subscription?.quote_cost,
              )
                ? "Please enter a valid quote cost"
                : " "}
            </FormHelperText>
          </FormControl>
        </Box>
        <Box sx={DialogStyle.emailWidth}>
          <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
            <InputLabel
              color={
                InputValidation.negativeValidation(dealer.subscription.overage)
                  ? "error"
                  : "primary"
              }
            >
              Per Pull Overage
            </InputLabel>
            <OutlinedInput
              required
              label="Per Pull Overage"
              value={dealer.subscription.overage}
              error={InputValidation.negativeValidation(
                dealer.subscription.overage,
              )}
              type="number"
              onChange={(event) =>
                setDealer({
                  ...dealer,
                  subscription: {
                    ...dealer.subscription,
                    overage: event.target.value,
                  },
                })
              }
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.negativeValidation(dealer.subscription.overage)
                ? "Please enter a valid pull overage"
                : " "}
            </FormHelperText>
          </FormControl>
          <FormControl variant="outlined" sx={DialogStyle.textFieldStyles}>
            <InputLabel id="demo-simple-select">Payload</InputLabel>
            <Select
              labelId="demo-simple-select"
              id="demo-simple"
              value={dealer.subscription.payload}
              label="Payload"
              onChange={(event) =>
                setDealer({
                  ...dealer,
                  subscription: {
                    ...dealer.subscription,
                    payload: event.target.value,
                  },
                })
              }
            >
              <MenuItem value={1}>Data</MenuItem>
              <MenuItem value={2}>Data & Docs</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Typography variant="h6">Opening Hours</Typography>
        {dealer?.dealershipTiming?.map((item, index) => (
          <Box key={item.day} sx={DialogStyle.openingHourBox}>
            <Box sx={{ width: "15%", justifyContent: "space-between" }}>
              <Checkbox
                checked={!item.isclosed}
                onChange={() => handleCheckboxChange(index)}
              />
              <span>{item.day}</span>
            </Box>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <MobileTimePicker
                label="Starts At"
                value={
                  item.opens_at
                    ? parseTimeStringToDate(item.opens_at)
                    : parseTimeStringToDate("09:00")
                }
                onChange={(newTime) => {
                  handleStartTimeChange(index, newTime);
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    {...params}
                    sx={{ width: "20%", mb: 2 }}
                  />
                )}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <MobileTimePicker
                label="Closes At"
                value={
                  item.closes_at
                    ? parseTimeStringToDate(item.closes_at)
                    : parseTimeStringToDate("21:00")
                }
                onChange={(newTime) => {
                  handleEndTimeChange(index, newTime);
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    {...params}
                    sx={{ width: "20%", mb: 2 }}
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
        ))}

        {/* Services....*/}
        <Typography variant="h6">Services</Typography>
        <DealershipService
          services={dealer.services}
          handleService={handleService}
        />
        <Box sx={DialogStyle.dealerButton}>
          {showSuccessMessage ? (
            <Box sx={{ display: "flex", my: "14px" }}>
              <CheckCircle color={"primary"} />
              <span
                style={{
                  color: theme.palette.primary.main,
                  marginLeft: "4px",
                }}
              >
                SUCCESS
              </span>
            </Box>
          ) : (
            <AppButton
              buttonText={edit ? "edit dealership" : "create dealership"}
              sx={{ width: "24vw" }}
              clickHandler={() => {
                edit ? editDealerHandler() : createDealerHandler();
              }}
              disabled={
                updateLoading ||
                dealer.dealershipName === "" ||
                dealer.contact.email == "" ||
                dealer.contact.phoneNumber == "" ||
                dealer.subscription?.cost === "" ||
                dealer.subscription?.limit === "" ||
                dealer.subscription?.overage === "" ||
                dealer.subscription?.quote_cost === "" ||
                InputValidation.nameValidation(dealer.dealershipName) ||
                InputValidation.emailValidation(dealer.contact.email) ||
                InputValidation.numberValidation(dealer.contact.phoneNumber) ||
                InputValidation.negativeValidation(dealer.subscription.cost) ||
                InputValidation.negativeValidation(dealer.subscription.limit) ||
                InputValidation.negativeValidation(
                  dealer.subscription.overage,
                ) ||
                InputValidation.negativeValidation(
                  dealer.subscription.quote_cost,
                ) ||
                InputValidation.addressValidation(dealer.address.poBox) ||
                InputValidation.addressValidation(dealer.address.city) ||
                InputValidation.addressValidation(dealer.address.street) ||
                InputValidation.zipCodeValidation(dealer.address.zipcode)
              }
              loading={updateLoading}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default HocPopup(NewDealershipForm);